<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card class="pa-3">
      <v-container>
        <h2 class="mb-3">Mein Konto</h2>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <td>{{ 'Benutzername' }}</td>
                <td>{{ userName }}</td>
              </tr>
              <tr>
                <td>{{ 'E-Mail' }}</td>
                <td>{{ userEmail }}</td>
              </tr>
              <tr>
                <td>{{ 'Benutzergruppen' }}</td>
                <td>
                  <div v-show="userGroups.length == 0">
                    {{ 'Keiner Benutzergruppe zugeordnet' }}
                  </div>
                  <div v-for="group in userGroups" :key="group">
                    <v-badge class="mb-1" color="grey">
                      <template v-slot:badge>
                        <span style="font-size: 1.1em">{{ group }}</span>
                      </template>
                    </v-badge>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  GET_USER,
  GET_USER_EMAIL,
  GET_USER_GROUPS,
  GET_USER_NAME,
  MODULE_NAME as AUTH_MODULE
} from '../global/auth/store/types'

export default {
  name: 'SettingsDialog',
  data() {
    return this.initialState()
  },
  methods: {
    initialState: function() {
      return {
        dialog: true
      }
    },
    reset: function() {
      this.$emit('close', true)
      Object.assign(this.$data, this.initialState())
    }
  },
  computed: {
    userName() {
      const userName = this.$store.getters[`${AUTH_MODULE}/${GET_USER_NAME}`]
      return userName ? userName : 'Kein Benutzername'
    },
    userEmail() {
      const userEmail = this.$store.getters[`${AUTH_MODULE}/${GET_USER_EMAIL}`]
      return userEmail ? userEmail : 'Keine E-Mail'
    },
    userGroups() {
      return this.$store.getters[`${AUTH_MODULE}/${GET_USER_GROUPS}`] || []
    }
  },
  watch: {
    dialog(val) {
      val || this.reset()
    }
  }
}
</script>
